import { Chips } from "../../../components/chips/chips";

// Resolves the provenance of a SubjectTask and renders it as a grey outline
// badge — the same <Chips> primitive used by the status badge, so it shares
// shape, font and sizing. Tasks on the subject plan originate in four ways and
// the backend marks each with a distinct field on the SubjectTask row:
//   - assignedByUserId           → assigned by an admin/user
//   - assignedBySubject          → self-assigned by the subject in the app
//   - dateScheduleActivityId /
//     triggerSubjectProfileFieldId → trigger/date-driven activity
//   - weeklyScheduleActivityId   → derived from the weekly plan template
// Used by both the plan TaskDrawer and the AssignedTaskDrawer so the label
// stays consistent regardless of which drawer opens.

export const SUBJECT_TASK_TYPE = {
  USER_ASSIGNED: "User-assigned",
  SELF_ASSIGNED: "Self-assigned",
  TRIGGERED: "Triggered",
  PLANNED: "Planned",
};

export const getSubjectTaskType = (task) => {
  if (!task) return SUBJECT_TASK_TYPE.PLANNED;
  if (task.assignedByUserId) return SUBJECT_TASK_TYPE.USER_ASSIGNED;
  if (task.assignedBySubject) return SUBJECT_TASK_TYPE.SELF_ASSIGNED;
  if (task.dateScheduleActivityId || task.triggerSubjectProfileFieldId) {
    return SUBJECT_TASK_TYPE.TRIGGERED;
  }
  return SUBJECT_TASK_TYPE.PLANNED;
};

const TaskTypeChip = ({ task, style }) => (
  <Chips text={getSubjectTaskType(task)} color="grey" style={style} />
);

export default TaskTypeChip;
